// extracted by mini-css-extract-plugin
export var button = "_9g-0";
export var icon = "_9g-1";